import { AbstractControl, FormControl } from '@angular/forms';
import { TitleId } from '@domgen/dgx-fe-common';
import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { PersonalDetailsFormField } from './personal-details-form-field.enum';

export interface PersonalDetailsForm {
  [PersonalDetailsFormField.Address]: AbstractControl<FormOverrideAddress>;
  [PersonalDetailsFormField.EmailAddress]: FormControl<string | null>;
  [PersonalDetailsFormField.FirstName]: FormControl<string | null>;
  [PersonalDetailsFormField.LastName]: FormControl<string | null>;
  [PersonalDetailsFormField.TelephoneNumber]: FormControl<string | null>;
  [PersonalDetailsFormField.TitleId]: FormControl<TitleId | null>;
}
